// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b9Xu","tabsBox":"styles_tabsBox__Z1bfb","createButton":"styles_createButton__3OA6F"};